import axios from '../../axios';
import { ADD_CUSTOMER, GET_CUSTOMER, UPDATE_CUSTOMER, GET_ONE_CUSTOMER } from '../types';
import { toast } from 'react-toastify';

export const getCustomer = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/user/all', { params });

      if (res.data.code === 1) {
         dispatch({ type: GET_CUSTOMER, payload: res.data.data });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const addCustomer = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/user/add', formData);

      if (res.data.code === 1) {
         dispatch({ type: ADD_CUSTOMER, payload: res.data.data });
         setTimeout(() => {
            toast.success('Customer added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const updateCustomer = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/user/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_CUSTOMER, payload: res.data.data });

         setTimeout(() => {
            toast.success('Customer updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

export const getSingleCustomer = (id) => async (dispatch) => {
   try {
      const res = await axios.get('/account/id', { params: { id: id } });

      if (res.data && res.data.code === 1) {
         dispatch({ type: GET_ONE_CUSTOMER, payload: res.data.data, single: res.data.data });
         return res.data.data
      } else {
         console.error('Invalid API response format');
      }
   } catch (error) {
      console.error('Error fetching vendor:', error);
   }
};
